export default __webpack_public_path__ + "static/media/logo-twitter.7261b91b.svg";